import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Container, Row } from 'reactstrap';

import SimpleHeader from 'components/Headers/SimpleHeader';
import FormInputs from './FormInputs';
import priceCatalogService from '../service/priceCatalogService';
import axios from 'axios';

function PriceCatalogForm(props) {
  const { id } = props.match.params;
  const [priceCatalog, setPriceCatalog] = useState({});

  useEffect(() => {
    const fetchPriceCatalog = async () => {
      try {
        const response = await priceCatalogService.getPriceCatalogById(id);
        if (!response?.data?.data) {
          console.warn('Dados do catálogo não encontrados');
          return;
        }
        setPriceCatalog(response.data.data);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          console.error('Erro ao carregar catálogo:', error.message);
        } else {
          console.error('Erro inesperado:', error);
        }
      }
    };
    if (id) {
      fetchPriceCatalog();
    }
  }, [id]);

  const renderWithBaseLayout = (children) => {
    return (
      <>
        <SimpleHeader showBackArrow="not" />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <div className="card-wrapper">
                <Card>
                  <CardHeader>
                    <div className="d-flex flex-row justify-content-between">
                      <h3 className="mb-0">Catálogo de Preços</h3>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">{children}</CardBody>
                </Card>
              </div>
            </div>
          </Row>
        </Container>
      </>
    );
  };

  const render = () => {
    return renderWithBaseLayout(
      <FormInputs id={id} priceCatalog={priceCatalog} />
    );
  };

  return render();
}

export default PriceCatalogForm;
